import { createAsyncThunk } from '@reduxjs/toolkit';
import { settings as APIsettings } from '../api/index.js';
import { notification } from 'antd';

const handleError = (message) => {
    notification.error({
        message: 'Error',
        description: message || 'Server error',
    });
};

export const fetchEmailTemplates = createAsyncThunk(
    'emailTemplates/fetchEmailTemplates',
    async (_, { rejectWithValue }) => {
        try {
            const response = await APIsettings.getEmailsTemplates();
            return response;
        } catch (error) {
            handleError(error.message);
            return rejectWithValue(error.message);
        }
    },
);

export const updateEmailTemplate = createAsyncThunk(
    'emailTemplates/updateEmailTemplate',
    async ({ data }, { rejectWithValue }) => {
        try {
            const templates = await APIsettings.updateEmailTemplate({ template: data });
            return templates;
        } catch (error) {
            handleError(error.message);
            return rejectWithValue(error.message);
        }
    },
);
